import script from "./DiscoverCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoverCard.vue?vue&type=script&setup=true&lang=js"

import "./DiscoverCard.vue?vue&type=style&index=0&id=8cab7224&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cab7224"]])

export default __exports__